import styled from "@emotion/styled";

/**
 * Holds content and contains no padding.
 */
export const DefaultContainer = styled.div`
  max-width: 1140px;
  margin: 0 auto;
`;
